import { Route, Routes } from "react-router-dom"
import LandingPage from "./pages/LandingPage";
import FilterPage from "./pages/FilterPage";
import ResultsPage from "./pages/ResultsPage";
import { Box, ChakraProvider, useColorModeValue } from '@chakra-ui/react';
import { Provider } from "react-redux";
import { store } from "./store/store.ts";

function App() {
  return (
    <Provider store={store}>
      <ChakraProvider>
        <Box minH={"100vh"} bg={useColorModeValue("gray.100")}>
          <Routes>
            <Route path='/' element={<LandingPage/>}/>
            <Route path='/webcam' element={<FilterPage/>}/>
            <Route path='/resultsReplaceMeLater' element={<ResultsPage/>}/>
          </Routes>
        </Box>
      </ChakraProvider>
    </Provider>
  );
}

export default App;
